import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter, BrowserRouter as Router, NavLink as RouterNavLink } from "react-router-dom"
import Moment from 'react-moment';
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import MaskedInput from "react-text-mask";
import {
  getAllProjectLead, addLeadNoteTab, getNoteLeadTab, addFollowNoteTab, getFollowLeadTab,
  getLeadCallLog, addLeadCallLog, addLeadEmailLog, getLeadEmailLog, deleteProjectCampLead, SendLeadEmail, SendLeadSms,
  getProjectLeadAct,
  addActivityProjectFollowUp,
  getProjectLeadCallLog,
  getProjectLeadEmailLog,
  getProjectLeadNote,
  addProjectLeadNote,
  addProjectLeadCallLog,
  addProjectLeadEmailLog,
  updateProjectOpenHouse
} from "../../../store/actions";
import DeleteModal from "../../../components/Common/DeleteModal";
import JoditEditor from 'jodit-react';
import Swal from 'sweetalert2';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import classnames from "classnames"
import noteImg from "../../../assets/images/rsicons/notes.png";
import follow from "../../../assets/images/rsicons/follow-up.png";
import phonelog from "../../../assets/images/rsicons/phone-log.png";
import emaillog from "../../../assets/images/rsicons/email-log.png";
import moment from "moment-timezone";
import projectIcon from "../../../assets/img/project-icon.png";
import clientIcon from "../../../assets/img/user-icon.png";
import leadIcon from "../../../assets/img/l-1.png";
import leadConversion from "../../../assets/img/conversion-icon.png";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  FormGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardFooter,
  CardTitle,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  Button
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import LeadChart from "../Projects/chart/lead-chart";
import ProjectFilterMenu from "./lead-filter-menu";
import RsCard from "components/Rscards/Rscard";
import RSBarChart from "components/charts/RSBarChart";
import RSPieChart from "components/charts/RSPieChart";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import Select from "react-select"
import PhoneInputField from "components/dropdowns/PhoneInputField";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import ActionActivity from "components/buttons/actionActivity";
import RsCardImgv5 from "components/Rscards/Rscard-imgv5";
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';
import RsLink from "components/buttons/rsLink";
import { Dropdown } from "primereact/dropdown";
import SafeField from "helpers/SafeField";
class ProjectLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lead: '',
      searchTerm: '',
      selectAll: false,
      selectedLeads: {},
      activeTab3: "2",
      projecttopfive: [],
      activePeriod: 'Today',
      activePeriod2: 'Today',
      newLeads: [],
      newActivity: [],
      projectOptions: [],
      expandedRow: {},
      expandedRows:null
    }
    this.toggleEmailCanvas = this.toggleEmailCanvas.bind(this);
    this.toggleFollowCanvas = this.toggleFollowCanvas.bind(this);
    this.toggleCallLogCanvas = this.toggleCallLogCanvas.bind(this);
    this.toggleEmailLogCanvas = this.toggleEmailLogCanvas.bind(this);
    this.toggleSmsLogCanvas = this.toggleSmsLogCanvas.bind(this);
    this.toggleAddNoteCanvas = this.toggleAddNoteCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.toggleSendMessageCanvas = this.toggleSendMessageCanvas.bind(this);
    this.submitLeadEmail = this.submitLeadEmail.bind(this);
    this.sendSMSSubmit = this.sendSMSSubmit.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.toggleOpenHouseCanvas = this.toggleOpenHouseCanvas.bind(this);
    this.updateOpenHouseData = this.updateOpenHouseData.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    //this.deleteOpenHouseData = this.deleteOpenHouseData.bind(this);
    this.dt = createRef();
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (lead) => {
    //
    this.setState({ lead: lead });
    this.setState({ deleteModal: true });
  };

  handleDeleteCampLeqad = () => {
    const { onDeleteCampLead } = this.props;
    const { lead } = this.state;
    
    if (lead.id !== undefined) {
      onDeleteCampLead(lead);
      this.setState({ deleteModal: false });
    }
  };

  updateOpenHouseData(values) {
    const updatedValues = {
      ...values,
      referedByContactId: values.referedByContactId ? parseInt(values.referedByContactId, 10) : 0,
    };

    this.props.updateProjectOpenHouse(updatedValues);
  }
  toggleOpenHouse() {
    this.setState(prevState => ({
      isEditOpenHouse: !prevState.isEditOpenHouse
    }));
  }
  toggleOpenHouseCanvas() {
    this.setState({ isEditOpenHouseData: {}, isEditOpenHouse: !this.state.isEditOpenHouse });
    this.toggleOpenHouse();
  }

  toggleOpenHouseCanvas = arg => {
    this.setState({ isEditOpenHouseData: arg });
    // onGetNoteLead(camplead.leadId);
    this.toggleOpenHouse();
  };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll
    }));
  }
  isAllCanavas = arg => {
    const lead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
        campaignProjectGuid: lead?.project?.projectGuid,
        campaignProjectId: lead?.project?.id,
        contactName: lead.firstName + " " + lead.lastName,
        email: lead.email,
        mobile: lead.mobile
      },
    });

    
    onGetFollowLead(lead.leadId, lead?.project?.projectGuid);
    onGetNoteLead(lead.leadId, lead?.project?.projectGuid);
    onGetLeadCallLog(lead.leadId, lead?.project?.projectGuid);
    onGetLeadEmailLog(lead.leadId, lead?.project?.projectGuid);
    onGetAllActLead(lead.leadId, lead?.project?.projectGuid)
    this.toggleAllCanavas();
  };
  onSearchChange(event) {
    this.setState({ searchTerm: event.target.value });
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }
  toggleFollow() {
    this.setState(prevState => ({
      isFollow: !prevState.isFollow
    }));

  }
  toggleAddNote() {
    this.setState(prevState => ({
      isAddNote: !prevState.isAddNote
    }));

  }

  toggleSendMessage() {
    this.setState(prevState => ({
      isSendMessage: !prevState.isSendMessage
    }));

  }
  toggleCallLog() {
    this.setState(prevState => ({
      isCallLog: !prevState.isCallLog
    }));

  }

  toggleEmailLog() {
    this.setState(prevState => ({
      isEmailLog: !prevState.isEmailLog
    }));

  }
  toggleSmsLog() {
    this.setState(prevState => ({
      isSmsLog: !prevState.isSmsLog
    }));

  }
  toggleEmailCanvas() {
    this.setState({ lead: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleAddNoteCanvas() {
    this.setState({ lead: "", isEdit: false, isFollow: !this.state.isAddNote });
    this.toggleAddNote();
  }
  toggleSendMessageCanvas() {
    this.setState({ lead: "", isEdit: false, isSendMessage: !this.state.isSendMessage });
    this.toggleSendMessage();
  }
  toggleFollowCanvas() {
    this.setState({ lead: "", isEdit: false, isFollow: !this.state.isFollow });
    this.toggleFollow();
  }

  toggleCallLogCanvas() {
    this.setState({ lead: "", isEdit: false, isCallLog: !this.state.isCallLog });
    this.toggleCallLog();
  }

  toggleEmailLogCanvas() {
    this.setState({ lead: "", isEdit: false, isEmailLog: !this.state.isEmailLog });
    this.toggleEmailLog();
  }
  toggleSmsLogCanvas() {
    this.setState({ lead: "", isEdit: false, isSmsLog: !this.state.isSmsLog });
    this.toggleSmsLog();
  }
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };
  componentDidMount() {
    const { onGetAllProjectLead } = this.props;
    onGetAllProjectLead(localStorage.getItem('userId'));
    this.buildProjectOptions(this.props.allleads);
    this.fetchNewLead(1, 'Today');
    this.fetchNewActivity(1, 'Today');
    this.fetchOptions();
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ProjectExt/getProjectCountByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {

        this.setState({ totalProject: res.data.countProject, totalClient: res.data.countClient, totalLead: res.data.countProjectLead, totalLeadtoClient: res.data.countProjectLeadtoClient });
      });

    axios.get(`${API_URL}ProjectExt/getProjectTopFiveProjectsByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ projecttopfive: res.data });
      });

  }
  componentDidUpdate(prevProps) {
    if (prevProps.allleads !== this.props.allleads) {
      this.buildProjectOptions(this.props.allleads);
    }
  }
  toggleEmailCanvas = arg => {
    const lead = arg;
    this.setState({
      lead: {
        id: lead.id,
        leadId: lead.leadId
      },
      isEdit: true,
    });
    this.toggle();
  };

  toggleFollowCanvas = arg => {
    const lead = arg;
    const { onGetFollowLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEditFollow: true,
    });
    onGetFollowLead(lead.leadId);
    this.toggleFollow();
  };
  toggleAddNoteCanvas = arg => {
    const lead = arg;
    const { onGetNoteLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEdit: true,
    });
    onGetNoteLead(lead.leadId);
    this.toggleAddNote();
  };

  toggleSendMessageCanvas = arg => {
    const lead = arg;
    const { onGetNoteLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,

      },
      isEdit: true,
    });
    //onGetNoteLead(lead.leadId);
    this.toggleSendMessage();
  };

  toggleCallLogCanvas = arg => {
    const lead = arg;
    const { onGetLeadCallLog } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEditCall: true,
    });
    onGetLeadCallLog(lead.leadId);
    this.toggleCallLog();
  };
  toggleEmailLogCanvas = arg => {
    const lead = arg;
    const { onGetLeadEmailLog } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEditCall: true,
    });
    onGetLeadEmailLog(lead.id);
    this.toggleEmailLog();
  };
  toggleSmsLogCanvas = arg => {
    const lead = arg;
    this.setState({
      lead: {
        leadId: lead.leadId
      },


    });
    this.toggleSmsLog();
  };

  handleSelectAll = () => {
    const { selectAll } = this.state;
    const { allleads } = this.props;
    const newSelectAll = !selectAll;
    const newSelectedLeads = {};

    if (Array.isArray(allleads)) {

      allleads.forEach(lead => {
        if (lead.id) {
          newSelectedLeads[lead.id] = newSelectAll;
        }
      });
    }

    this.setState({
      selectAll: newSelectAll,
      selectedLeads: newSelectedLeads
    });
  };
  handleSelectLead = (id) => {
    const { selectedLeads } = this.state;
    const newSelectedLeads = { ...selectedLeads, [id]: !selectedLeads[id] };


    const anySelected = Object.keys(newSelectedLeads).some((key) => newSelectedLeads[key]);

    this.setState({
      selectedLeads: newSelectedLeads,
      anySelected
    });
  };
  submitLeadEmail(value, history) {
    this.props.SendLeadEmail(value);
  }
  sendSMSSubmit(value, history) {
    this.props.SendLeadSms(value);
  }
  handleFollowPlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('activityLocation', place.formatted_address);
        setFieldValue('activityLatitude', longitude);
        setFieldValue('activityLongitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleDeleteSelectedLeads = () => {
    const selectedIds = Object.keys(this.state.selectedLeads)
      .filter((id) => this.state.selectedLeads[id])
      .map(Number);
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to delete ${selectedIds.length} lead(s). This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete them!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.sendSelectedToAPI(selectedIds);
      }
    });
  };

  sendSelectedToAPI = async (selectedIds) => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = "Bearer " + token;
      const response = await fetch(`${API_URL}ProjectCampaignLead/bulkDeleteCampaignLeads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': str
        },
        body: JSON.stringify(selectedIds),
      });

      if (response.ok) {
        const result = await response.json();
        const { onGetAllProjectLead } = this.props;
        onGetAllProjectLead(localStorage.getItem('userId'));
        Swal.fire('Deleted!', `${selectedIds.length} lead(s) have been deleted.`, 'success');
      } else {
        console.error("API Error:", response.statusText);
        Swal.fire('Error', 'Failed to delete the leads.', 'error');
      }
    } catch (error) {
      console.error("Request Failed:", error);
      Swal.fire('Error', 'Something went wrong.', 'error');
    }
  };
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        //
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };

  fetchNewActivity(days, periodLabel) {
    this.setState({ loading: true, activePeriod2: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectActivityForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newActivity: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });


  }

  fetchNewLead(days, periodLabel) {
    this.setState({ loading: true, activePeriod: periodLabel });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem("userId"),
      day: days,
    };
    axios
      .get(`${API_URL}ProjectExt/getProjectCampaignLeadForDashboardByDay`, { headers, params })
      .then((response) => {
        this.setState({ newLeads: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchOptions = () => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    axios.get(`${API_URL}ContactExt/allforagent`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { agentId }
    })
      .then((res) => {
        const filteredOptions = res.data.map((item) => ({
          value: `${item.id}`,
          label: `${item.firstName} ${item.lastName} - ${item.email}`,
        }));

        this.setState({ optionGroup1: filteredOptions, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching referrals:", error);
        this.setState({ isLoading: false });
      });
  };

  buildProjectOptions(leads) {
    if (!leads) return;
    const uniqueProjects = [...new Set(leads.map(l => l.project?.projectName).filter(Boolean))];
    this.setState({
      projectOptions: uniqueProjects.map(p => ({ label: p, value: p }))
    });
  }
  toggleRow = (index) => {
    this.setState((prevState) => ({
      expandedRow: {
        ...prevState.expandedRow,
        [index]: !prevState.expandedRow[index],
      },
    }));
  };

  render() {
    //
    const { onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog } = this.props;
    const { leadNotes, leadFollows, calllogs, emaillogs, activities, notes, isResponsive } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { allleads } = this.props;
    const { selectAll, selectedLeads, anySelected, isEditOpenHouseData, activePeriod, activePeriod2, newLeads, newActivity, deleteModal, projectOptions, expandedRow } = this.state;
    const lead = this.state.lead;
    const { isEdit, isEditFollow, isEditCall, isEditEmail, deleteLeadModal, searchTerm, totalProject, totalClient, totalLead, totalLeadtoClient, projecttopfive } = this.state;
    const showTrashButton = anySelected || (selectAll && allleads.length > 0);
    const { optionGroup1, isLoading } = this.state;

    const filteredLeads = allleads?.filter(lead =>
      lead.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.phone.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead?.project?.projectName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const reports = [
      { title: "# Active projects", iconClass: projectIcon, description: totalProject },
      {
        title: "# Leads",
        iconClass: leadIcon,
        description: totalLead,
      },
      {
        title: "Leads to client conversion",
        iconClass: leadConversion,
        description: totalLeadtoClient + "%",
      },

    ];

    // 
    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteCampLeqad}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <ToastContainer autoClose={2000} />
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}


        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>

          <Container fluid className="">
            {/* Render Breadcrumbs */}

            <Row className="mb20 project-header">
              <Col lg="12">
                <Breadcrumbs
                  title={this.props.t("Projects")}
                  breadcrumbItem={this.props.t("Projects Lead")}
                />
              </Col>

              {/* <Col lg="6">

              </Col> */}
            </Row>
            <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">

              {reports.map((report, key) => (
                <div key={key} className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                  <RsCardImgv4 key={key} title={report.title} description={report.description} iconClass={report.iconClass} isResponsive={isResponsive} />
                </div>
              ))}

            </div>
            <Row>

              <Col lg="4" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">
                    <div className="card-title mb-4 float-start card-bottom-border">Top 5 Projects</div>
                    {!isResponsive ? (
                      <Table
                        id=""
                        className="table table-striped table-bordered border-left-off"
                      >
                        <thead>
                          <tr>
                            <th>Project</th>
                            <th>City</th>

                            <th># Leads</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projecttopfive.map((project, index) => (
                            <tr key={index}>
                              <td>{project.projectName}</td>
                              <td>{project.city}</td>

                              <td>{project.noOfLead}</td>
                            </tr>
                          ))}


                        </tbody>
                      </Table>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped mb-0">
                          <tbody>
                            {projecttopfive.map((project, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  onClick={() => this.toggleRow(index)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td className="fw-bold">
                                    {project.projectName}
                                    <Button
                                      color="link"
                                      size="sm"
                                      className="float-end p-0"
                                    >
                                      {expandedRow[index] ? "▲" : "▼"}
                                    </Button>
                                    <div className="text-muted small">{project.city}</div>
                                  </td>
                                </tr>

                                {expandedRow[index] && (
                                  <tr className="bg-light">
                                    <td colSpan="3">
                                      <table className="table table-sm mb-0">
                                        <tbody>
                                          <tr>
                                            <th>Project</th>
                                            <td>{project.projectName}</td>
                                          </tr>
                                          <tr>
                                            <th>City</th>
                                            <td>{project.city}</td>
                                          </tr>
                                          <tr>
                                            <th># Leads</th>
                                            <td>{project.noOfLead}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                  </CardBody>
                </Card>

              </Col>

              <Col lg="4" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">
                    <h5 className="card-title card-bottom-border w-100" style={{ marginBottom: 10 }}>New leads

                      <span className="float-end" >
                        {isResponsive ? (
                          <select
                            className="form-select w-auto"
                            value={activePeriod}
                            onChange={(e) => {
                              const val = e.target.value;
                              const days =
                                val === "Today" ? 1 : val === "Yesterday" ? 2 : 7;
                              this.fetchNewLead(days, val);
                            }}
                          >
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Last 7 Days">Last 7 Days</option>
                          </select>
                        ) : (
                          <Router>
                            <Nav tabs className="float-end projectTab actTabs">
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod === 'Today'} onClick={() => this.fetchNewLead(1, 'Today')}>
                                  <span className="d-none d-sm-block">Today</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod === 'Yesterday'} onClick={() => this.fetchNewLead(2, 'Yesterday')}>
                                  <span className="d-none d-sm-block">Yesterday</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod === 'Last 7 Days'} onClick={() => this.fetchNewLead(7, 'Last 7 Days')}>
                                  <span className="d-none d-sm-block">Last 7 Days</span>
                                </NavLink>
                              </NavItem>

                            </Nav>

                          </Router>
                        )}

                      </span>

                    </h5>
                    <div className="clearfix"></div>
                    {isResponsive ? (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped mb-0">
                          <tbody>
                            {map(newLeads, (data, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  onClick={() => this.toggleRow(index)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td className="fw-bold">
                                    {data.firstName + " " + data.lastName}
                                    <button
                                      className="btn btn-link btn-sm float-end p-0"
                                      style={{ fontSize: "1rem" }}
                                    >
                                      {expandedRow[index] ? "▲" : "▼"}
                                    </button>
                                    <div className="text-muted small">
                                      <Moment format="D MMM YY">{data.addedDate}</Moment>
                                    </div>
                                  </td>
                                </tr>

                                {expandedRow[index] && (
                                  <tr className="bg-light">
                                    <td>
                                      <table className="table table-sm mb-0">
                                        <tbody>
                                          <tr>
                                            <th>Project</th>
                                            <td>{data.projectName}</td>
                                          </tr>
                                          <tr>
                                            <th>Source</th>
                                            <td>
                                              {data.leadSourceId
                                                ? localization[
                                                "LeadSource_" + data.leadSourceId
                                                ]
                                                : "Manual"}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="table-responsive" style={{ maxHeight: '220px', overflowY: 'auto' }}>

                        <table className="table mb-0 table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Name</th>

                              <th>Project</th>
                              <th>Source</th>


                            </tr>
                          </thead>
                          <tbody>
                            {map(newLeads, (data, prokey) => (
                              <tr key={prokey}>
                                <td><Moment format="D MMM YY">{data.addedDate}</Moment></td>
                                <td>{data.firstName + " " + data.lastName}</td>

                                <td>{data.projectName}</td>
                                <td>{data.leadSourceId ? localization["LeadSource_" + data.leadSourceId] : 'Manual'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                      </div>
                    )}

                  </CardBody>
                </Card>
              </Col>

              <Col lg="4" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">
                    <h5 className="card-title card-bottom-border w-100" style={{ marginBottom: 10 }}>Follow Up Activity

                      <span className="float-end" >
                        {isResponsive ? (
                          <select
                            className="form-select w-auto"
                            value={activePeriod2}
                            onChange={(e) => {
                              const val = e.target.value;
                              const days =
                                val === "Today" ? 1 : val === "Tomorrow" ? 2 : 7;
                              this.fetchNewActivity(days, val);
                            }}
                          >
                            <option value="Today">Today</option>
                            <option value="Tomorrow">Tomorrow</option>
                            <option value="This Week">This Week </option>
                          </select>
                        ) : (
                          <Router>
                            <Nav tabs className="float-end projectTab actTabs">

                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'Today'} onClick={() => this.fetchNewActivity(1, 'Today')}>
                                  <span className="d-none d-sm-block">Today</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'Tomorrow'} onClick={() => this.fetchNewActivity(2, 'Tomorrow')}>
                                  <span className="d-none d-sm-block">Tomorrow</span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink as={Link} to="#" active={activePeriod2 === 'This Week'} onClick={() => this.fetchNewActivity(7, 'This Week')}>
                                  <span className="d-none d-sm-block">This Week</span>
                                </NavLink>
                              </NavItem>
                            </Nav>

                          </Router>
                        )}

                      </span>

                    </h5>
                    <div className="clearfix"></div>
                    <div className="table-responsive" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                      <table className="table mb-0 table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Name</th>
                            {/* <th>Phone</th>
                                      <th>Email</th> */}
                            <th>Type</th>
                            <th>Project</th>


                          </tr>
                        </thead>
                        <tbody>
                          {map(newActivity, (data, prokey) => (
                            <tr key={prokey}>
                              <td><Moment format="D MMM YY">{data.activityStartDate}</Moment></td>
                              <td>{data.contactName}</td>
                              {/* <td>{data.contactPhone}</td>
                                       <td>{data.contactEmail}</td> */}
                              <td>{
                                localization[
                                "ActivitySubType_" +
                                data.activityType +
                                "_" +
                                data.activitySubType
                                ]
                              }</td>
                              <td>{data.projectName}</td>
                            </tr>
                          ))}



                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>



            </Row>

            <Row>
              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-8">
                        <ProjectFilterMenu />
                      </div>

                    </div>
                  </CardHeader>

                  <CardBody>
                    <div className="row mb20">

                      <div className="col-sm-4">
                        {showTrashButton && (
                          <Link to="#" className="btn btn-del" onClick={this.handleDeleteSelectedLeads}>
                            <i className="bx bx-trash font-size-24"></i>
                          </Link>
                        )}

                      </div>
                      <div className="col-sm-4">


                      </div>



                    </div>
                    <div className="clearfix"></div>

                    {isResponsive ? (
                      <DataTable
                        value={filteredLeads}
                        paginator
                        rows={10}
                        stripedRows
                        responsiveLayout="scroll"
                        expandedRows={this.state.expandedRows}
                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                        rowExpansionTemplate={(lead) => (
                          <table className="table table-sm mb-0 bg-light">
                            <tbody>
                              <tr>
                                <th>Project</th>
                                <td>{lead.project ? lead.project.projectName : "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Date</th>
                                <td>
                                  {lead.lastContact ? (
                                    <Moment format="D MMM YY">{lead.lastContact}</Moment>
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Phone</th>
                                <td>{lead.mobile || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Email</th>
                                <td>{lead.email || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Actions</th>
                                <td>
                                  <ActionActivity onClick={() => this.isAllCanavas(lead)} />{" "}
                                  <ActionEdit onClick={() => this.toggleOpenHouseCanvas(lead)} />{" "}
                                  <ActionDelete onClick={() => this.onClickDelete(lead)} />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                      >
                        <Column expander style={{ width: "3rem" }} />
                        <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />

                        <Column
                          field="firstName"
                          header="Name"
                          body={(lead) => (
                            <div>
                              <strong>{`${lead.firstName} ${lead.lastName}`}</strong>
                              <div className="text-muted small">{lead.email}</div>
                            </div>
                          )}
                        />
                        <Column
                          field="project.projectName"
                          header="Project"
                          body={(lead) => lead.project ? lead.project.projectName : ""}
                        />
                      </DataTable>
                    ) : (
                      <DataTable
                        ref={this.dt}
                        value={filteredLeads}
                        selection={this.state.selectedLeads}
                        stripedRows
                        onSelectionChange={(e) => this.setState({ selectedLeads: e.value })}
                        dataKey="id"
                        paginator
                        rows={10}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                      >
                        {/* Selection Checkbox */}
                         <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />

                        <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />


                        <Column
                          field="firstName"
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                          header={this.props.t("Name")}
                          body={(lead) => `${lead.firstName} ${lead.lastName}`}

                        />


                        <Column
                          field="project.projectName"
                          header={this.props.t("Project")}
                          body={(lead) => lead.project ? lead.project.projectName : ''}
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                          filterElement={(options) => (
                            <Dropdown
                              value={options.value}
                              options={this.state.projectOptions}
                              onChange={(e) => options.filterApplyCallback(e.value)}
                              placeholder="Select Project"
                              showClear
                              className="p-column-filter"
                              style={{ minWidth: '12rem' }}
                            />
                          )}

                        />

                        {/* Date */}
                        <Column
                          field="lastContact"
                          header={this.props.t("Date")}
                          body={(lead) => lead.lastContact ? <Moment format="D MMM YY">{lead.lastContact}</Moment> : ''}

                        />

                        {/* Phone */}
                        <Column field="mobile" header={this.props.t("Phone")}
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}

                        />

                        {/* Email */}
                        <Column field="email" header={this.props.t("Email")}
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                        />

                        {/* Actions */}
                        <Column
                          headerClassName="action-header"
                          header={
                            <div className="justify-content-end">
                              <RsLink
                                onClick={() => this.dt.current.reset()}
                                iconClass="bx bx-reset"
                                className="btn-light"
                              >
                                Reset all filters
                              </RsLink>
                            </div>
                          }
                          body={(lead) => (
                            <>
                              <ActionActivity onClick={() => this.isAllCanavas(lead)} />{" "}
                              <ActionEdit onClick={() => this.toggleOpenHouseCanvas(lead)} />{" "}
                              <ActionDelete onClick={() => this.onClickDelete(lead)} />
                            </>
                          )}
                        />
                      </DataTable>
                    )}

                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Offcanvas
              isOpen={this.state.isEditOpenHouse}
              direction="end"
              toggle={this.toggleOpenHouseCanvas}

            >
              <OffcanvasHeader toggle={this.toggleOpenHouseCanvas}>
                {/* {this.state.isEditOpenHouseData.name} */}
                Update Lead
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: isEditOpenHouseData?.id,
                    projectCampaignLeadId: isEditOpenHouseData?.projectCampaignLeadId,
                    projectCampaignId: isEditOpenHouseData?.id,
                    campaignProjectId: isEditOpenHouseData?.project?.id,
                    //projectCampaignGuid: isEditOpenHouseData?.projectCampaignGuid,
                    campaignProjectGuid: isEditOpenHouseData?.project?.projectGuid,
                    firstName: isEditOpenHouseData?.firstName,
                    lastName: isEditOpenHouseData?.lastName,
                    phone: isEditOpenHouseData?.phone,
                    mobile: isEditOpenHouseData?.mobile,
                    email: isEditOpenHouseData?.email,
                    leadAddressId: isEditOpenHouseData?.leadAddressId,
                    fullAddress: isEditOpenHouseData?.leadAddress?.fullAddress,
                    addressLine1: isEditOpenHouseData?.leadAddress?.addressLine1,
                    addressLine2: isEditOpenHouseData?.leadAddress?.addressLine2,
                    nearestIntersection: isEditOpenHouseData?.leadAddress?.nearestIntersection,
                    city: isEditOpenHouseData?.leadAddress?.city,
                    province: isEditOpenHouseData?.leadAddress?.province,
                    postal: isEditOpenHouseData?.leadAddress?.postal,
                    country: isEditOpenHouseData?.leadAddress?.country,
                    leadId: isEditOpenHouseData?.leadId,
                    leadGuid: isEditOpenHouseData?.leadGuid,
                    agentId: isEditOpenHouseData?.agentId,
                    leadSourceText: isEditOpenHouseData?.leadSourceText,
                    referedByContactId: isEditOpenHouseData?.referedByContactId,

                  }}
                  validationSchema={Yup.object().shape({
                    firstName: Yup.string().required("This is required"),
                    lastName: Yup.string().required("This is required"),
                    //phone: Yup.string().matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'Enter number is not valid'),
                    mobile: Yup.string().required('This is required'),
                    email: Yup.string().email('Enter Valid Email').required('This is required')

                  })}

                  onSubmit={this.updateOpenHouseData}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="firstName">
                              {this.props.t("First Name *")}
                            </Label>
                            <SafeField
                              name="firstName"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.firstName && touched.firstName
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="firstName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="lastName">
                              {this.props.t("Last Name *")}
                            </Label>
                            <SafeField
                              name="lastName"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.lastName && touched.lastName
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <PhoneInputField
                            label="Phone"
                            name="phone"
                            value={values.phone}
                            setFieldValue={setFieldValue}
                            error={errors.phone}
                            touched={touched.phone}
                            country="ca"
                            required={false}
                          />

                        </Col>
                        <Col md="12">
                          <PhoneInputField
                            label="Mobile"
                            name="mobile"
                            value={values.mobile}
                            setFieldValue={setFieldValue}
                            error={errors.mobile}
                            touched={touched.mobile}
                            country="ca"
                            required={false}
                          />

                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="email">
                              {this.props.t("Email *")}
                            </Label>
                            <SafeField
                              name="email"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.email && touched.email
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="fullAddress">
                              {this.props.t("Address")}
                            </Label>


                            <PlacesAutocomplete
                              value={values.fullAddress}
                              onChange={(value) => setFieldValue('fullAddress', value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: 'Enter Address...',
                                      className: 'form-control',

                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}

                                    {suggestions.map((suggestion, i) => {
                                      const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                      const style = suggestion.active
                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                      return (
                                        <div
                                          key={i}
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>


                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="leadSourceText">
                              {this.props.t("Source")}
                            </Label>
                            <SafeField
                              name="leadSourceText"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.leadSourceText && touched.leadSourceText
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="leadSourceText"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="referredBy">
                              {this.props.t("Referred By")}
                            </Label>
                            <Select

                              name="referedByContactId"
                              isMulti={false}
                              value={optionGroup1.find(
                                (option) => parseInt(option.value) === parseInt(values.referedByContactId)
                              ) || null}
                              onChange={(selectedOption) => {
                                setFieldValue("referedByContactId", selectedOption ? selectedOption.value : "");
                              }}
                              options={optionGroup1}
                              classNamePrefix="select2-selection"
                              isLoading={isLoading}
                            />

                            <ErrorMessage
                              name="referredBy"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                      </Row>
                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isAll}
              direction="end"
              toggle={this.isAllCanavas}
              style={{ width: 800 }}
              s
            >
              <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>

              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "2",
                      })}
                      onClick={() => {
                        this.toggle3("2");
                      }}
                    >
                      All Activities
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "1",
                      })}
                      onClick={() => {
                        this.toggle3("1");
                      }}
                    >
                      Follow Up
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "3",
                      })}
                      onClick={() => {
                        this.toggle3("3");
                      }}
                    >
                      Message
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "4",
                      })}
                      onClick={() => {
                        this.toggle3("4");
                      }}
                    >
                      Add Notes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "5",
                      })}
                      onClick={() => {
                        this.toggle3("5");
                      }}
                    >
                      Call Log
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "6",
                      })}
                      onClick={() => {
                        this.toggle3("6");
                      }}
                    >
                      Email Log
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={this.state.activeTab3}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          agentId: parseInt(localStorage.getItem("userId")),
                          title: "Call log",
                          contactname: lead.contactName,
                          contactphone: lead.mobile,
                          contactemail: lead.email,
                          //addedDate: new Date(),
                          activityStartDate: new Date(),
                          startTime: "",
                          endTime: "",
                          activityStatus: 1,
                          activityType: 3,
                          activityRefId: lead.leadId,
                          activityDescription: (this.state && this.state.activityDescription) || "",
                          activityLocationType: 3,
                          activityLocation: "",
                          activityParentRefGuid: lead.campaignProjectGuid,
                          activityParentRefTypeId: lead.campaignProjectId,
                          isActive: true,
                          category: 3
                        }}
                        validationSchema={Yup.object().shape({
                          activityDescription: Yup.string().required("This is Required")
                        })}
                        onSubmit={(values) => {
                          const formattedValues = {
                            ...values,
                            activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

                          };
                          onAddLeadFollowUp(formattedValues);
                          this.toggleAllCanavas();

                        }}

                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >

                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">

                                  <div className="clearfix"></div>
                                  <div className="btn-group" role="group">
                                    <SafeField type="radio" className="btn-check"
                                      name="activityType" id="btnradio4"
                                      value={3}
                                      checked={values.activityType === 3}
                                      onChange={() => {
                                        setFieldValue("activityType", 3)
                                        setFieldValue("title", "Call Log")
                                      }}
                                      autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                                    <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={10}
                                      checked={values.activityType === 10}

                                      onChange={() => {
                                        setFieldValue("activityType", 10)
                                        setFieldValue("title", "Message")
                                      }}

                                      autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>

                                    <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                      value={4}
                                      checked={values.activityType === 4}

                                      onChange={() => {
                                        setFieldValue("activityType", 4)
                                        setFieldValue("title", "Email")
                                      }}
                                      autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>

                                    <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                      checked={values.activityType === 1}

                                      onChange={() => {
                                        setFieldValue("activityType", 1)
                                        setFieldValue("title", "Meeting")
                                      }}

                                      autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>


                                  </div>
                                  <ErrorMessage
                                    name="activityType"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">

                                  <textarea
                                    name="activityDescription"
                                    onChange={handleChange}
                                    type="textarea"
                                    className={
                                      "form-control" +
                                      (errors.activityDescription && touched.activityDescription
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="activityDescription"
                                  />
                                  <ErrorMessage
                                    name="activityDescription"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="12">
                                <FormGroup className="mb15">

                                  <Label htmlFor="activityStartDate">
                                    Date
                                  </Label>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.activityStartDate && touched.activityStartDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.activityStartDate}
                                    onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                  <ErrorMessage
                                    name="logDate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>

                              </Col>
                            </Row>
                            {values.activityType === 1 && (
                              <>
                                <Row>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="startTime">
                                        {this.props.t("Start Time")}
                                      </Label>
                                      <Row>
                                        <Col md="4">
                                          <SafeField
                                            name="startHrs"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleStartTime(setFieldValue, { ...values, startHrs: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.startHrs && touched.startHrs
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value="">Hrs</option>
                                            {[...Array(12)].map((_, i) => (
                                              <option key={i + 1} value={i + 1} label={i + 1}>
                                                {i + 1}
                                              </option>
                                            ))}
                                          </SafeField>
                                          <ErrorMessage
                                            name="startHrs"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                        <Col md="4">
                                          <SafeField
                                            name="startMin"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleStartTime(setFieldValue, { ...values, startMin: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.startMin && touched.startMin
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value="">Mins</option>
                                            {[0, 15, 30, 45].map((value) => (
                                              <option key={value} value={value}>
                                                {value === 0 ? '00' : value}
                                              </option>
                                            ))}
                                          </SafeField>
                                          <ErrorMessage
                                            name="startMin"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                        <Col md="4">
                                          <SafeField
                                            name="startDif"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleStartTime(setFieldValue, { ...values, startDif: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.startDif && touched.startDif
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value='AM'>AM</option>
                                            <option value='PM'>PM</option>
                                          </SafeField>
                                          <ErrorMessage
                                            name="startDif"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                  </Col>
                                  <Col md="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="endTime">
                                        {this.props.t("End Time")}
                                      </Label>
                                      <Row>
                                        <Col md="4">
                                          <SafeField
                                            name="endHrs"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.endHrs && touched.endHrs
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value="">Hrs</option>
                                            {[...Array(12)].map((_, i) => (
                                              <option key={i + 1} value={i + 1} label={i + 1}>
                                                {i + 1}
                                              </option>
                                            ))}
                                          </SafeField>
                                          <ErrorMessage
                                            name="endHrs"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                        <Col md="4">
                                          <SafeField
                                            name="endMin"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.endMin && touched.endMin
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value="">Mins</option>
                                            {[0, 15, 30, 45].map((value) => (
                                              <option key={value} value={value}>
                                                {value === 0 ? '00' : value}
                                              </option>
                                            ))}
                                          </SafeField>
                                          <ErrorMessage
                                            name="endMin"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                        <Col md="4">
                                          <SafeField
                                            name="endDif"
                                            as="select"

                                            onChange={e => {
                                              handleChange(e);
                                              this.handleEndTime(setFieldValue, { ...values, endDif: e.target.value });
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.endDif && touched.endDif
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id="hrs"
                                          >
                                            <option value='AM'>AM</option>
                                            <option value='PM'>PM</option>
                                          </SafeField>
                                          <ErrorMessage
                                            name="endDif"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                  </Col>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="notes">
                                        {this.props.t("Location")}
                                      </Label>
                                      <div className="clearfix"></div>
                                      <div className="btn-group" role="group">

                                        <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio91" value={3}
                                          onChange={() => setFieldValue("activityLocationType", 3)}
                                          autoComplete="off" />
                                        <label className="btn btn-outline-secondary" htmlFor="btnradio91">In-person</label>
                                        <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio101" value={1}
                                          onChange={() => setFieldValue("activityLocationType", 1)}
                                          autoComplete="off" />
                                        <label className="btn btn-outline-secondary" htmlFor="btnradio101">Online</label>
                                      </div>

                                    </FormGroup>
                                  </Col>

                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="addressLine1">
                                        {this.props.t("Location")}
                                      </Label>
                                      {values.activityLocationType === 3 ? (
                                        <PlacesAutocomplete
                                          value={values.activityLocation}
                                          onChange={(value) => setFieldValue('activityLocation', value)}
                                          onSelect={(value) => this.handleFollowPlaceSelected(value, setFieldValue)}
                                        >
                                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                            <div>
                                              <input
                                                {...getInputProps({
                                                  placeholder: 'Enter Address...',
                                                  className: 'form-control',

                                                })}
                                              />
                                              <div className="">
                                                {loading ? <div>Loading...</div> : null}

                                                {suggestions.map((suggestion, i) => {
                                                  const className = suggestion.active
                                                    ? 'suggestion-item--active'
                                                    : 'suggestion-item';
                                                  const style = suggestion.active
                                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                  return (
                                                    <div
                                                      key={i}
                                                      {...getSuggestionItemProps(suggestion, {
                                                        style,
                                                      })}
                                                    >
                                                      {suggestion.description}
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          )}
                                        </PlacesAutocomplete>
                                      ) : (
                                        <SafeField
                                          name="activityLocation"
                                          onChange={handleChange}
                                          type="text"
                                          className={
                                            "form-control" +
                                            (errors.activityLocation && touched.activityLocation
                                              ? " is-invalid"
                                              : "")
                                          }
                                          id="activityLocation"

                                        />
                                      )}
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                          </Form>
                        )}
                      </Formik>


                      <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(leadFollows, (follLog, follLogkey) => (

                          <li className="event-list eventlist" key={"_note_" + follLogkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>


                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14"></h5>
                              </div>
                            </div>
                            <div className="exNote">{follLog.activityDetails}</div>
                          </li>
                        ))}

                      </ul>

                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div className="tabContent">
                      <ul className="verti-timeline list-unstyled">
                        {map(
                          activities,
                          (allactivity, allactkey) => (
                            <li
                              className="event-list eventlist"
                              key={"_allact_" + allactkey}
                            >
                              <div className="event-timeline-dot">
                                {(() => {
                                  if (
                                    allactivity.activitySubType ==
                                    8 ||
                                    allactivity.activitySubType ==
                                    9 ||
                                    allactivity.activitySubType ==
                                    7
                                  ) {
                                    return (
                                      <>
                                        <img src={emaillog} />
                                      </>
                                    );
                                  } else if (
                                    allactivity.activitySubType ==
                                    3 ||
                                    allactivity.activitySubType ==
                                    4 ||
                                    allactivity.activitySubType ==
                                    5
                                  ) {
                                    return (
                                      <>
                                        <img src={phonelog} />
                                      </>
                                    );
                                  } else if (
                                    allactivity.activitySubType ==
                                    10
                                  ) {
                                    return (
                                      <>
                                        <img src={follow} />
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <img src={noteImg} />
                                      </>
                                    );
                                  }
                                })()}
                              </div>
                              <div className="d-flex">
                                <div className="flex-shrink-0 me-3">
                                  <h5 className="font-size-14">
                                    <Moment format="D MMM YY">
                                      {allactivity.addedDate}
                                    </Moment>
                                  </h5>
                                </div>
                                <div className="flex-grow-1">
                                  <h5 className="font-size-14">
                                    {
                                      localization[
                                      "ActivitySubType_" +
                                      allactivity.activityType +
                                      "_" +
                                      allactivity.activitySubType
                                      ]
                                    }
                                  </h5>
                                </div>
                              </div>
                              <div className="exNote">
                                {allactivity.activityRemarks}
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </TabPane>

                  <TabPane tabId="3">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{

                          //refId: lead.leadId,
                          addMessage: (this.state && this.state.addMessage) || "",



                        }}
                        validationSchema={Yup.object().shape({
                          addMessage: Yup.string().required("This is Required")
                        })}

                        onSubmit=""
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >

                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="addNote">
                                    {this.props.t("Send Message")}
                                  </Label>
                                  <textarea
                                    name="addMessage"
                                    onChange={handleChange}
                                    type="textarea"
                                    className={
                                      "form-control" +
                                      (errors.addMessage && touched.addMessage
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="addMessage"
                                  />
                                  <ErrorMessage
                                    name="addMessage"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                          </Form>
                        )}
                      </Formik>
                      <div className="mb-5 h4 card-title mt-20">Message History</div>
                    </div>
                  </TabPane>
                  <TabPane tabId="4">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{

                          refId: lead.leadId,
                          remarks: (this.state && this.state.remarks) || "",
                          addedDate: new Date(),
                          addedBy: parseInt(localStorage.getItem('userId')),
                          activityParentRefId: lead.leadId,
                          activityParentRefGuid: lead.campaignProjectGuid

                        }}
                        validationSchema={Yup.object().shape({
                          remarks: Yup.string().required("This is Required")
                        })}

                        onSubmit={values => {
                          onAddLeadNote(values)
                          this.toggleAllCanavas();
                        }}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >

                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="remarks">
                                    {this.props.t("Add Note")}
                                  </Label>
                                  <textarea
                                    name="remarks"
                                    onChange={handleChange}
                                    type="textarea"
                                    className={
                                      "form-control" +
                                      (errors.remarks && touched.remarks
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="remarks"
                                  />
                                  <ErrorMessage
                                    name="remarks"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                          </Form>
                        )}
                      </Formik>
                      <div className="mb-5 h4 card-title mt-20">Notes History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(notes, (noteLog, notekey) => (

                          <li className="event-list eventlist" key={"_note_" + notekey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14"></h5>
                              </div>
                            </div>
                            <div className="exNote">{noteLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </div>
                  </TabPane>
                  <TabPane tabId="5">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          actionType: '',
                          refId: lead.leadId,
                          addedDate: new Date(),
                          remarks: '',
                          addedBy: localStorage.getItem('userId'),
                          activityParentRefId: lead.leadId,
                          activityParentRefGuid: lead.campaignProjectGuid
                        }}
                        validationSchema={Yup.object().shape({
                          actionType: Yup.string().required(
                            "Please Select Action"
                          ),
                          remarks: Yup.string().required(
                            "Enter Note"
                          ),
                        })}

                        onSubmit={values => {

                          onAddCallLog(values)
                          this.toggleAllCanavas();
                        }}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >

                            <Row className="mt20 mb20">



                              <Col lg="12">
                                <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType1" value="No Answer"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }} />
                                    No Answer
                                  </label>
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }}
                                    />
                                    Left Voicemail
                                  </label>
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }}
                                    />
                                    Bad Number
                                  </label>

                                </div>
                                <ErrorMessage
                                  name="actionType"
                                  component="div"
                                  className="invalid-feedback"
                                />

                              </Col>

                            </Row>
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="addedDate">
                                    Log Date
                                  </Label>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.addedDate && touched.addedDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.addedDate}
                                    onChange={(value) => setFieldValue('addedDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                  <ErrorMessage
                                    name="addedDate"
                                    component="div"
                                    className="invalid-feedback"
                                  />

                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="remarks">
                                    Add Message
                                  </Label>
                                  <SafeField
                                    name="remarks"

                                    as="textarea"

                                    className="form-control"
                                    value={values.remarks}
                                    onChange={(e) => setFieldValue("remarks", e.target.value)}
                                    id="remarks"

                                  />
                                  <ErrorMessage
                                    name="remarks"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                          </Form>
                        )}
                      </Formik>
                      <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(calllogs, (callLog, callkey) => (

                          <li className="event-list eventlist" key={"_call_" + callkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                              </div>
                            </div>
                            <div className="exNote">{callLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </div>
                  </TabPane>
                  <TabPane tabId="6">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          actionType: '',
                          refId: lead.leadId,
                          addedDate: new Date(),
                          remarks: '',
                          addedBy: localStorage.getItem('userId'),
                          activityParentRefId: lead.leadId,
                          activityParentRefGuid: lead.campaignProjectGuid

                        }}
                        validationSchema={Yup.object().shape({
                          actionType: Yup.string().required(
                            "Please Select Action"
                          )
                        })}

                        onSubmit={values => {
                          onAddEmailLog(values)
                          this.toggleAllCanavas();
                        }}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >

                            <Row className="mt20 mb20">



                              <Col lg="12">
                                <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }}
                                    />
                                    Email Sent
                                  </label>
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType2" value="Email Received"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }}
                                    />
                                    Email Received
                                  </label>
                                  <label>
                                    <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced"
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue("remarks", e.target.value);
                                      }}
                                    />
                                    Email Bounced
                                  </label>

                                </div>
                                <ErrorMessage
                                  name="actionType"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>

                            </Row>
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="addedDate">
                                    Log Date
                                  </Label>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.addedDate && touched.addedDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.addedDate}
                                    onChange={(value) => setFieldValue('addedDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                  <ErrorMessage
                                    name="addedDate"
                                    component="div"
                                    className="invalid-feedback"
                                  />

                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="remarks">
                                    Add Message
                                  </Label>
                                  <SafeField
                                    name="remarks"
                                    onChange={handleChange}
                                    as="textarea"

                                    className="form-control"

                                    id="remarks"

                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                          </Form>
                        )}
                      </Formik>
                      <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(emaillogs, (emailLog, emailkey) => (

                          <li className="event-list eventlist" key={"_email_" + emailkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                              </div>
                            </div>
                            <div className="exNote">{emailLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </div>
                  </TabPane>
                </TabContent>



              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleEmailCanvas}
              style={{ width: 600 }}
            >
              <OffcanvasHeader toggle={this.toggleEmailCanvas}>
                Send Email
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    emailLeadId: lead.leadId,
                    emailLeadTemplateId: 0,
                    emailLeadSubject: '',
                    emailLeadFullContent: '',
                    agentId: parseInt(localStorage.getItem('userId')),
                    isActive: true,
                    emailLeadSendStatus: 'pending',
                    emailLeadCss: '',
                    emailLeadTitle: '',
                    emailLeadContent: '',


                  }}
                  validationSchema={Yup.object().shape({
                    emailLeadSubject: Yup.string().required("This is Required")
                  })}

                  onSubmit={this.submitLeadEmail}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>
                        <Col md="12">

                          <FormGroup className="mb-3">
                            <Label htmlFor="emailLeadSubject">
                              {this.props.t("Subject *")}
                            </Label>
                            <SafeField
                              name="emailLeadSubject"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.emailLeadSubject && touched.emailLeadSubject
                                  ? " is-invalid"
                                  : "")
                              }
                              id="emailLeadSubject"
                            />
                            <ErrorMessage
                              name="emailLeadSubject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                        </Col>

                        <Col md="12">
                          <JoditEditor
                            value={values.body}
                            onBlur={(newContent) => {
                              setFieldValue('emailLeadFullContent', newContent);
                            }}
                            config={{
                              readonly: false,
                              placeholder: "Start typing here...",
                              height: 400,
                            }}
                          />
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isAddNote}
              direction="end"
              toggle={this.toggleAddNoteCanvas}
            >
              <OffcanvasHeader toggle={this.toggleAddNoteCanvas}>
                Add Notes
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{

                    refId: lead.leadId,
                    addNote: (this.state && this.state.addNote) || "",



                  }}
                  validationSchema={Yup.object().shape({
                    addNote: Yup.string().required("This is Required")
                  })}

                  onSubmit={values => {

                    if (isEdit) {
                      
                      onAddLeadNote(values)
                      //onAddLeadNote(updateData);
                    } else {

                    }
                    //
                    //this.toggleAddNote();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="addNote">
                              {this.props.t("Add Note")}
                            </Label>
                            <textarea
                              name="addNote"
                              onChange={handleChange}
                              type="textarea"
                              className={
                                "form-control" +
                                (errors.addNote && touched.addNote
                                  ? " is-invalid"
                                  : "")
                              }
                              id="addNote"
                            />
                            <ErrorMessage
                              name="addNote"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                    </Form>
                  )}
                </Formik>
                <div className="mb-5 h4 card-title mt-20">Notes History</div>
                <ul className="verti-timeline list-unstyled">

                  {map(leadNotes, (noteLog, notekey) => (

                    <li className="event-list eventlist" key={"_note_" + notekey}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle font-size-18" />
                      </div>
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <h5 className="font-size-14">
                            <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                          </h5>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="font-size-14"></h5>
                        </div>
                      </div>
                      <div className="exNote">{noteLog.activityRemarks}</div>
                    </li>
                  ))}

                </ul>
              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isSendMessage}
              direction="end"
              toggle={this.toggleSendMessageCanvas}
            >
              <OffcanvasHeader toggle={this.toggleSendMessageCanvas}>
                Send Message
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{

                    smsLeadId: lead.leadId,
                    smsLeadTemplateId: 0,
                    smsLeadFullContent: (this.state.smsLeadContent) || "",
                    agentId: parseInt(localStorage.getItem('userId')),
                    isActive: true,
                    smsLeadContent: (this.state && this.state.smsLeadContent) || "",
                    smsLeadSendStatus: 'Sent'


                  }}
                  validationSchema={Yup.object().shape({
                    smsLeadContent: Yup.string().required("This is Required")
                  })}

                  onSubmit={(values) => {
                    // Ensure smsLeadFullContent matches smsLeadContent
                    const updatedValues = {
                      ...values,
                      smsLeadFullContent: values.smsLeadContent
                    };
                    this.sendSMSSubmit(updatedValues);
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="smsLeadContent">
                              {this.props.t("Message")}
                            </Label>
                            <textarea
                              name="smsLeadContent"
                              onChange={handleChange}
                              type="textarea"
                              className={
                                "form-control" +
                                (errors.smsLeadContent && touched.smsLeadContent
                                  ? " is-invalid"
                                  : "")
                              }
                              id="smsLeadContent"
                            />
                            <ErrorMessage
                              name="smsLeadContent"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                    </Form>
                  )}
                </Formik>
                <div className="mb-5 h4 card-title mt-20">Message History</div>
                <ul className="verti-timeline list-unstyled">

                  {map(leadNotes, (noteLog, notekey) => (

                    <li className="event-list eventlist" key={"_note_" + notekey}>
                      {/* <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14"></h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{noteLog.activityRemarks}</div> */}
                    </li>
                  ))}

                </ul>
              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isCallLog}
              direction="end"
              toggle={this.toggleCallLogCanvas}
              style={{ width: 800 }}
            >
              <OffcanvasHeader toggle={this.toggleCallLogCanvas}>
                Call Log
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    actionType: '',
                    addedDate: new Date(),
                    refId: lead.id


                  }}
                  validationSchema={Yup.object().shape({
                    actionType: Yup.string().required(
                      "Please Select Action"
                    )
                  })}

                  onSubmit={values => {

                    if (isEditCall) {

                      onAddCallLog(values)
                      //onAddLeadNote(updateData);
                    } else {

                    }
                    this.toggleCallLog();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row className="mt20 mb20">



                        <Col lg="12">
                          <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" onChange={handleChange} />
                              No Answer
                            </label>
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" onChange={handleChange} />
                              Left Voicemail
                            </label>
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" onChange={handleChange} />
                              Bad Number
                            </label>

                          </div>
                          <ErrorMessage
                            name="actionType"
                            component="div"
                            className="invalid-feedback"
                          />

                        </Col>

                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="addedDate">
                              Log Date
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.addedDate && touched.addedDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.addedDate}
                              onChange={(value) => setFieldValue('addedDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d"
                              }}
                            />
                            <ErrorMessage
                              name="addedDate"
                              component="div"
                              className="invalid-feedback"
                            />

                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="callNote">
                              Add Message (Optional)
                            </Label>
                            <textarea
                              name="callNote"
                              onChange={handleChange}
                              type="textarea"

                              className="form-control"

                              id="callNote"

                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                    </Form>
                  )}
                </Formik>
                <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                <ul className="verti-timeline list-unstyled">

                  {map(calllogs, (callLog, callkey) => (

                    <li className="event-list eventlist" key={"_call_" + callkey}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle font-size-18" />
                      </div>
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <h5 className="font-size-14">
                            <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                          </h5>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                        </div>
                      </div>
                      <div className="exNote">{callLog.activityRemarks}</div>
                    </li>
                  ))}

                </ul>
              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isFollow}
              direction="end"
              toggle={this.toggleFollowCanvas}

            >
              <OffcanvasHeader toggle={this.toggleFollowCanvas}>
                Follow Us
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    refId: lead.id,
                    addNote: (this.state && this.state.addNote) || "",
                    nextFollowupDate: new Date(),


                  }}
                  validationSchema={Yup.object().shape({
                    addNote: Yup.string().required("This is Required")
                  })}

                  onSubmit={values => {

                    if (isEditFollow) {

                      onAddLeadFollowUp(values)

                    } else {

                    }
                    this.toggleFollow();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">

                            <textarea
                              name="addNote"
                              onChange={handleChange}
                              type="textarea"
                              className={
                                "form-control" +
                                (errors.addNote && touched.addNote
                                  ? " is-invalid"
                                  : "")
                              }
                              id="addNote"
                            />
                            <ErrorMessage
                              name="addNote"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb15">

                            <Label htmlFor="logDate">
                              Date
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.nextFollowupDate && touched.nextFollowupDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.nextFollowupDate}
                              onChange={(value) => setFieldValue('nextFollowupDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d"
                              }}
                            />
                            <ErrorMessage
                              name="logDate"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                        </Col>
                      </Row>

                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                    </Form>
                  )}
                </Formik>
                <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                <ul className="verti-timeline list-unstyled">

                  {map(leadFollows, (follLog, follLogkey) => (

                    <li className="event-list eventlist" key={"_note_" + follLogkey}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle font-size-18" />
                      </div>
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <h5 className="font-size-14">
                            <Moment format="D MMM YY">{follLog.activityRefStartDate}</Moment>


                          </h5>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="font-size-14"></h5>
                        </div>
                      </div>
                      <div className="exNote">{follLog.activityRemarks}</div>
                    </li>
                  ))}

                </ul>

              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isEmailLog}
              direction="end"
              toggle={this.toggleEmailLogCanvas}
              style={{ width: 800 }}
            >
              <OffcanvasHeader toggle={this.toggleEmailLogCanvas}>
                Email Log
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    actionType: '',
                    addedDate: new Date(),
                    refId: lead.id

                  }}
                  validationSchema={Yup.object().shape({
                    actionType: Yup.string().required(
                      "Please Select Action"
                    )
                  })}

                  onSubmit={values => {

                    if (isEditCall) {

                      onAddEmailLog(values)
                      //onAddLeadNote(updateData);
                    } else {

                    }
                    this.toggleEmailLog();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row className="mt20 mb20">



                        <Col lg="12">
                          <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent" onChange={handleChange} />
                              Email Sent
                            </label>
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType2" value="Email Received" onChange={handleChange} />
                              Email Received
                            </label>
                            <label>
                              <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced" onChange={handleChange} />
                              Email Bounced
                            </label>

                          </div>
                          <ErrorMessage
                            name="actionType"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>

                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="addedDate">
                              Log Date
                            </Label>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.addedDate && touched.addedDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.addedDate}
                              onChange={(value) => setFieldValue('addedDate', value[0])}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d"
                              }}
                            />
                            <ErrorMessage
                              name="addedDate"
                              component="div"
                              className="invalid-feedback"
                            />

                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="remarks">
                              Add Message (Optional)
                            </Label>
                            <textarea
                              name="remarks"
                              onChange={handleChange}
                              type="textarea"

                              className="form-control"

                              id="remarks"

                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                    </Form>
                  )}
                </Formik>
                <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                <ul className="verti-timeline list-unstyled">

                  {map(emaillogs, (emailLog, emailkey) => (

                    <li className="event-list eventlist" key={"_email_" + emailkey}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle font-size-18" />
                      </div>
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <h5 className="font-size-14">
                            <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                          </h5>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                        </div>
                      </div>
                      <div className="exNote">{emailLog.activityRemarks}</div>
                    </li>
                  ))}

                </ul>
              </OffcanvasBody>
            </Offcanvas>


          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ProjectLead.propTypes = {

  className: PropTypes.any,
  t: PropTypes.any,
  onGetAllProjectLead: PropTypes.func,
  allleads: PropTypes.array,
  loading: PropTypes.object,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  leadNotes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  notes: PropTypes.array,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onDeleteCampLead: PropTypes.func,
  SendLeadEmail: PropTypes.func,
  SendLeadSms: PropTypes.func,
  notes: PropTypes.array,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  updateProjectOpenHouse: PropTypes.func,
  isResponsive: PropTypes.object
}

const mapStateToProps = ({ Project, leads, projectleads }) => ({
  allleads: Project.allleads,
  loading: Project.loading,
  leadNotes: leads.leadNotes,
  leadFollows: leads.leadFollows,

  activities: projectleads.activities,
  followups: projectleads.followups,
  notes: projectleads.notes,
  calllogs: projectleads.calllogs,
  emaillogs: projectleads.emaillogs,
  leadFollows: projectleads.leadFollows
})

const mapDispatchToProps = dispatch => ({
  onGetAllProjectLead: (agentId) => dispatch(getAllProjectLead(agentId)),
  onAddLeadNote: (data) => dispatch(addProjectLeadNote(data)),
  onGetNoteLead: (leadId, projectGuid) => dispatch(getProjectLeadNote(leadId, projectGuid)),
  onGetFollowLead: (leadId) => dispatch(getFollowLeadTab(leadId)),

  onAddLeadFollowUp: (data) => dispatch(addActivityProjectFollowUp(data)),
  onAddCallLog: (data) => dispatch(addProjectLeadCallLog(data)),
  onGetLeadCallLog: (leadId, projectGuid) => dispatch(getProjectLeadCallLog(leadId, projectGuid)),
  onAddEmailLog: (data) => dispatch(addProjectLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId, projectGuid) => dispatch(getProjectLeadEmailLog(leadId, projectGuid)),
  onDeleteCampLead: (id) => dispatch(deleteProjectCampLead(id)),
  SendLeadEmail: (data) => dispatch(SendLeadEmail(data)),
  SendLeadSms: (data) => dispatch(SendLeadSms(data)),

  onGetAllActLead: (leadId, projectGuid) => dispatch(getProjectLeadAct(leadId, projectGuid)),
  updateProjectOpenHouse: (data) => dispatch(updateProjectOpenHouse(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectLead)))